import React, { lazy } from 'react';
import { GiftIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const BONUSES = [{
  title: 'BONO 1 — El Mapa de Triggers',
  desc: 'Descubrí exactamente qué enciende la crisis antes de que explote.',
  price: '$9.000',
  image: 'https://cdn.magicpatterns.com/uploads/uq2h4FhtaxN7saE1DCd6Hi/mocap_bono_1.png'
}, {
  title: 'BONO 2 — Tablero de Recompensas Sin Sobornos',
  desc: 'Cooperación real sin premios a cada rato.',
  price: '$9.000',
  image: 'https://cdn.magicpatterns.com/uploads/vDwGJxziamDzGjGYHkXep1/mocap_bono_2.png'
}, {
  title: 'BONO 3 — Kit Anti-Pantallas',
  desc: 'Ideas rápidas para apagar el "dame el celular" sin drama.',
  price: '$9.000',
  image: 'https://cdn.magicpatterns.com/uploads/7LaUuEhM2bPD8cYDXqNn7T/mocap_bono_3.png'
}, {
  title: 'BONO 4 — La Guía de Acuerdos Familiares',
  desc: 'Reglas claras, menos estrés, más paz.',
  price: '$9.000',
  image: 'https://cdn.magicpatterns.com/uploads/ixbJgeMx6VB6ENbtogwfiH/mocap_bono_4.png'
}];
export function BonusSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-20 px-4 bg-white" data-id="element-14">
      <div className="max-w-6xl mx-auto" data-id="element-15">
        <div className="text-center mb-16" data-id="element-16">
          <div className="inline-flex items-center justify-center gap-3 bg-red-600 text-white px-8 py-4 rounded-2xl shadow-xl transform rotate-1" data-id="element-17">
            <GiftIcon className="w-8 h-8 animate-bounce" data-id="element-18" />
            <h2 className="text-2xl md:text-4xl font-black uppercase tracking-wide" data-id="element-19">
              MÁS TUS 4 BONOS EXCLUSIVOS — GRATIS
            </h2>
          </div>
          <p className="text-xl text-gray-600 mt-6 font-medium" data-id="element-20">
            Solo si te sumás el día de hoy
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16" data-id="element-21">
          {BONUSES.map((bonus, idx) => <div key={idx} className="flex flex-col items-center text-center group" data-id="element-22">
              {/* Real Bonus Image */}
              <div className="w-full aspect-square max-w-[280px] relative mb-6 rounded-2xl shadow-2xl overflow-hidden cursor-pointer transform group-hover:-translate-y-2 transition-transform duration-300" onClick={scrollToPricing} data-id="element-23">
                <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover" loading="lazy" decoding="async" width={280} height={280} data-id="element-24" />
                {/* GRATIS Badge */}
                <div className="absolute top-3 right-3 bg-yellow-400 text-yellow-900 text-xs font-black py-1.5 px-4 rounded-full shadow-lg uppercase tracking-wider animate-pulse" data-id="element-25">
                  🎁 GRATIS HOY
                </div>
              </div>

              <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-26">
                🎁 {bonus.title}
              </h3>
              <p className="text-gray-600 mb-3 flex-1" data-id="element-27">{bonus.desc}</p>
              <div className="text-sm font-bold text-gray-400 bg-gray-50 px-3 py-1 rounded-full" data-id="element-28">
                Valor real: <span className="line-through" data-id="element-29">{bonus.price}</span>
              </div>
            </div>)}
        </div>

        <div className="text-center" data-id="element-30">
          <CTAButton text="👉 QUIERO EL PACK COMPLETO CON LOS BONOS" onClick={scrollToPricing} data-id="element-31" />
        </div>
      </div>
    </section>;
}